/**
 * @module Local Page - Column Content
 * @description
 */
import styles from "./ColumnContentLocal.module.css";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const { headline, subhead, copy, theme } = props;

  const states = [
    { url: "/local/alabama", title: "Alabama" },
    { url: "/local/arizona", title: "Arizona" },
    { url: "/local/california", title: "California" },
    { url: "/local/connecticut", title: "Connecticut" },
    { url: "/local/florida", title: "Florida" },
    { url: "/local/georgia", title: "Georgia" },
    { url: "/local/illinois", title: "Illinois" },
    { url: "/local/indiana", title: "Indiana" },
    { url: "/local/iowa", title: "Iowa" },
    { url: "/local/michigan", title: "Michigan" },
    { url: "/local/minnesota", title: "Minnesota" },
    { url: "/local/mississippi", title: "Mississippi" },
    { url: "/local/nebraska", title: "Nebraska" },
    { url: "/local/nevada", title: "Nevada" },
    { url: "/local/new-mexico", title: "New Mexico" },
    { url: "/local/new-york", title: "New York" },
    { url: "/local/north-carolina", title: "North Carolina" },
    { url: "/local/north-dakota", title: "North Dakota" },
    { url: "/local/ohio", title: "Ohio" },
    { url: "/local/pennsylvania", title: "Pennsylvania" },
    { url: "/local/south-carolina", title: "South Carolina" },
    { url: "/local/south-dakota", title: "South Dakota" },
    { url: "/local/tennessee", title: "Tennessee" },
    { url: "/local/texas", title: "Texas" },
    { url: "/local/utah", title: "Utah" },
    { url: "/local/virginia", title: "Virginia" },
    { url: "/local/west-virginia", title: "West Virginia" },
    { url: "/local/wisconsin", title: "Wisconsin" },
  ];

  return (
    <>
      <section
        className={`component ${styles.component} ${theme && `u-theme-${theme}`}`}
      >
        <div className="l-container">
          {headline && (
            <div className={styles.component__header}>
              <div className="g-row g-row--vertical-center">
                <div className="g-col g-col--one-half--large">
                  <h2
                    className={`h2 ${styles.component__headline} ${theme && styles[`component__headline__${theme}`]}`}
                  >
                    {headline}
                  </h2>
                </div>
                <div className="g-col g-col--one-half--large">
                  {subhead && (
                    <h3 className={`h5 ${styles.component__subhead}`}>
                      {subhead}
                    </h3>
                  )}
                  {copy && <p>{copy}</p>}
                </div>
              </div>
            </div>
          )}

          {states && (
            <div className={`${styles.component__itemList}`}>
              <ul className={styles.component__links}>
                {states.map((state, index) =>
                  state.url ? (
                    <li key={index}>
                      <a
                        className={`${styles.component__link} ${theme && styles[`component__link__${theme}`]}`}
                        href={state.url}
                      >
                        {state.title}
                      </a>
                    </li>
                  ) : (
                    <li key={index}>{state.title}</li>
                  ),
                )}
              </ul>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Component;
